module.exports = "data:image/svg+xml;base64,bW9kdWxlLmV4cG9ydHMgPSBfX3dlYnBhY2tfcHVibGljX3BhdGhfXyArICJsb2dvLTRmYTM1YmZhYWIzZDU1NDAzMGU1N2U5NGJjOGI5ZWNmLnN2ZyI7"


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/logo.svg
// module id = 658
// module chunks = 0